var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevBtnInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-6.2%",
    width: "112.5%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "prevBtnInactive_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prevBtnInactive_svg__b",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 25 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prevBtnInactive_svg__a)",
    xlinkHref: "#prevBtnInactive_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prevBtnInactive_svg__b"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2276E3",
    strokeWidth: 3,
    opacity: 0.402,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 9l-4 4 4 4"
  }))));
}
export default SvgPrevBtnInactive;